var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.show
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "mx-5 xl:mx-44 2xl:mx-40 my-8 w-auto h-auto flex flex-col items-center space-y-10"
  }, [_c('h3', [_vm._v("Ajouter un nouveau lien d'affiliation")]), _vm._v(" "), _c('input-text', {
    attrs: {
      "name": "structure_name",
      "libelle": "",
      "placeholder": "Nom de la structure affiliée",
      "value": _vm.name
    },
    on: {
      "input": function (newValue) {
        _vm.name = newValue;
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "bg-color": "bg-pink-600",
      "border-color": "border-pink-600",
      "disabled": false,
      "icon": "arrow-right_1",
      "icon-color": "text-white",
      "libelle": "Créer",
      "text-color": "text-white",
      "right": true,
      "uppercase": true,
      "spinner": _vm.loading
    },
    on: {
      "clickAction": function ($event) {
        return _vm.addNewAffiliate();
      }
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }